/** Purchasing subnav tips — clicks pass through onto the GR heading. */
export const PURCHASING_NAV_TOOLTIP_PROPS = {
  placement: 'bottom',
  mouseLeaveDelay: 0,
  destroyTooltipOnHide: true,
  overlayClassName: 'purchasing-nav-tooltip',
  overlayStyle: { pointerEvents: 'none' },
  getPopupContainer: () => document.body,
}

const TALKJS_TOAST_STYLE_ID = 'oms-talkjs-purchasing-chrome'

/**
 * TalkJS popup/toast defaults to covering the page. Pin it to the bottom
 * corner and let clicks through the empty wrapper onto headings / subnav.
 */
export const TALKJS_POPUP_CHROME = {
  keepOpen: true,
  launcher: 'close-only',
}

export const ensureTalkJsToastDoesNotCoverNav = () => {
  if (typeof document === 'undefined') return
  if (document.getElementById(TALKJS_TOAST_STYLE_ID)) return
  const style = document.createElement('style')
  style.id = TALKJS_TOAST_STYLE_ID
  style.textContent = `
    .__talkjs_popup {
      top: auto !important;
      bottom: 24px !important;
      right: 24px !important;
      left: auto !important;
      pointer-events: none;
    }
    .__talkjs_popup iframe,
    .__talkjs_popup > * {
      pointer-events: auto;
    }
  `
  document.head.appendChild(style)
}
